import * as React from 'react';
import { TPAComponentProps } from '../../types';

export interface CardProps extends TPAComponentProps {
  stacked?: boolean;
  children?: React.ReactNode;
}

export interface CardContainerProps extends TPAComponentProps {
  children: React.ReactNode;
  minWidth?: number | string;
}

export interface CardDefaultProps {
  stacked: false;
}

export enum CardDataHooks {
  CardRoot = 'card-root',
  CardContainer = 'card-container',
}

export enum CardDataKeys {
  Stacked = 'data-stacked',
}
